"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;

var _styledComponents = require("styled-components");

var _styles = require("react-components/styles");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Font families.
 */
var fontFamilies = {
  inter: '"Inter", sans-serif',
  saira: '"Saira", sans-serif'
};
/**
 * Heading 1.
 */

var heading1 = (0, _styledComponents.css)(["font-family:", ";font-size:48px;font-weight:300;letter-spacing:-1px;line-height:52px;", ""], fontFamilies.saira, _styles.media.min('ms')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 79px;\n    letter-spacing: -3px;\n    line-height: 80px;\n  "]))));
/**
 * Heading 2.
 */

var heading2 = (0, _styledComponents.css)(["font-family:", ";font-size:40px;font-weight:400;letter-spacing:-1px;line-height:44px;", ""], fontFamilies.saira, _styles.media.min('ms')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 56px;\n    font-weight: 300;\n    letter-spacing: -2px;\n    line-height: 56px;\n  "]))));
/**
 * Heading 3.
 */

var heading3 = (0, _styledComponents.css)(["font-family:", ";font-size:28px;font-weight:400;letter-spacing:-0.5px;line-height:32px;", ""], fontFamilies.saira, _styles.media.min('ms')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 40px;\n    letter-spacing: -1px;\n    line-height: 48px;\n  "]))));
/**
 * Heading 4.
 */

var heading4 = (0, _styledComponents.css)(["font-family:", ";font-size:24px;font-weight:400;letter-spacing:-0.5px;line-height:28px;", ""], fontFamilies.saira, _styles.media.min('ms')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 28px;\n    line-height: 32px;\n  "]))));
/**
 * Text large.
 */

var textLarge = (0, _styledComponents.css)(["font-family:", ";font-size:20px;font-weight:400;letter-spacing:-0.5px;line-height:24px;", ""], fontFamilies.inter, _styles.media.min('ms')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: 22px;\n    line-height: 26px;\n  "]))));
/**
 * Text medium.
 */

var textMedium = (0, _styledComponents.css)(["font-family:", ";font-size:18px;font-weight:400;letter-spacing:-0.5px;line-height:24px;", ""], fontFamilies.inter, _styles.media.min('ms')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: 20px;\n    line-height: 26px;\n  "]))));
/**
 * Text normal.
 */

var textNormal = (0, _styledComponents.css)(["font-family:", ";font-size:16px;font-weight:400;letter-spacing:-0.5px;line-height:22px;"], fontFamilies.inter);
/**
 * Text small.
 */

var textSmall = (0, _styledComponents.css)(["font-family:", ";font-size:13px;font-weight:400;letter-spacing:-0.5px;line-height:19px;", ""], fontFamilies.inter, _styles.media.min('ms')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 20px;\n  "]))));
/**
 * Text extra small.
 */

var textExtraSmall = (0, _styledComponents.css)(["font-family:", ";font-size:11px;font-weight:400;letter-spacing:-0.5px;line-height:15px;"], fontFamilies.inter);
/**
 * Caption medium.
 */

var captionMedium = (0, _styledComponents.css)(["font-family:", ";font-size:16px;font-weight:400;letter-spacing:-0.2px;line-height:22px;"], fontFamilies.saira);
/**
 * Caption small.
 */

var captionSmall = (0, _styledComponents.css)(["font-family:", ";font-size:14px;font-weight:400;letter-spacing:-0.2px;line-height:20px;"], fontFamilies.saira);
/**
 * Caption extra small.
 */

var captionExtraSmall = (0, _styledComponents.css)(["font-family:", ";font-size:12px;font-weight:400;letter-spacing:-0.2px;line-height:18px;"], fontFamilies.saira);
/**
 * Export `typography` styles.
 */

var typography = {
  fontFamilies: fontFamilies,
  styles: {
    captionExtraSmall: captionExtraSmall,
    captionMedium: captionMedium,
    captionSmall: captionSmall,
    heading1: heading1,
    heading2: heading2,
    heading3: heading3,
    heading4: heading4,
    textExtraSmall: textExtraSmall,
    textLarge: textLarge,
    textMedium: textMedium,
    textNormal: textNormal,
    textSmall: textSmall
  }
};
exports.typography = typography;